/* eslint-disable camelcase */
import React, { useState, useEffect, useRef } from 'react';
import { breakpoints } from '../../../../../config/constants';
import ArticleCardBase from '../../Base';
import Image from '../../../../Image';
import { inheritChildStyle } from '../../../../../helpers/text';

import './styles.scss';

const PortraitSocialEmbedInstagram = ({ data, endCard }) => {
  const { backgroundColor, sectionTitle, caption, instagramPostId } = data;
  const [embedPostData, setEmbedPostData] = useState(null);
  const [imageToDisplay, setImageToDisplay] = useState(null);
  const INSTAGRAM_EMBED_URL = `https://www.instagram.com/p/${instagramPostId}`;
  const noTitle =
    sectionTitle === null && caption === null ? 'portrait-social-embed-instagram__no-title' : '';
  const captionTextRef = useRef();

  function handleResize() {
    if (!embedPostData) return;

    const imageData = {
      caption: embedPostData.imageCaption
    };

    // Resource Index: 0 for mobile, 1 for tablet and 2 for desktop.
    const [mobileImg, tabletImg, desktopImg] = embedPostData.displayResources;
    let postImageSrc = mobileImg;

    if (window.innerWidth >= breakpoints.tablet && window.innerWidth < breakpoints.smallDesktop) {
      postImageSrc = tabletImg;
    } else if (window.innerWidth >= breakpoints.smallDesktop) {
      postImageSrc = desktopImg;
    }

    setImageToDisplay({
      ...imageData,
      src: postImageSrc.src
    });
  }

  useEffect(() => {
    if (captionTextRef.current) {
      inheritChildStyle(captionTextRef.current, 'a', 'color');
    }

    window
      .fetch(`${INSTAGRAM_EMBED_URL}/?__a=1`, {
        method: 'GET'
      })
      .then(response => response.json())
      .then(postData => {
        if (postData) {
          const mediaData = postData.graphql.shortcode_media;
          const { display_resources, edge_media_to_caption } = mediaData;
          const { edge_followed_by, profile_pic_url, username } = mediaData.owner;

          setEmbedPostData({
            username,
            profilePicUrl: profile_pic_url,
            followerCount: edge_followed_by.count.toLocaleString(),
            displayResources: display_resources.length ? display_resources : [],
            imageCaption: edge_media_to_caption.edges.length
              ? edge_media_to_caption.edges[0].node.text
              : ''
          });
        }
      });

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (embedPostData) {
      window.addEventListener('resize', handleResize);
      handleResize();
      return () => window.removeEventListener('resize', handleResize);
    }
  }, [embedPostData]);

  return (
    <ArticleCardBase variation="portrait" accentColor1={backgroundColor} endCard={endCard}>
      <section className={`card-container portrait-social-embed-instagram ${noTitle}`}>
        <div
          className="portrait-social-embed-instagram__title"
          dangerouslySetInnerHTML={{ __html: sectionTitle }}
        />
        <div
          ref={captionTextRef}
          className="portrait-social-embed-instagram__caption"
          dangerouslySetInnerHTML={{ __html: caption }}
        />
        {embedPostData ? (
          <div className="portrait-social-embed-instagram__widget-wrapper">
            <div className="portrait-social-embed-instagram__header">
              <div className="portrait-social-embed-instagram__avatar-container">
                <a
                  href={`https://www.instagram.com/${embedPostData.username}`}
                  className="portrait-social-embed-instagram__avatar"
                  target="_blank"
                  rel="noopener noreferrer">
                  <img src={embedPostData.profilePicUrl} alt={embedPostData.username} />
                </a>
              </div>
              <div className="portrait-social-embed-instagram__header-text">
                <a
                  href={`https://www.instagram.com/${embedPostData.username}`}
                  className="portrait-social-embed-instagram__username"
                  target="_blank"
                  rel="noopener noreferrer">
                  <span className="portrait-social-embed-instagram__username-text">
                    {embedPostData.username}
                  </span>
                </a>
                <div className="portrait-social-embed-instagram__header-secondary-content">
                  <span className="portrait-social-embed-instagram__follower-count-text">
                    {`${embedPostData.followerCount} followers`}
                  </span>
                </div>
              </div>
            </div>
            {imageToDisplay ? (
              <div className="portrait-social-embed-instagram__widget-media-wrapper">
                <div className="portrait-social-embed-instagram__widget-media">
                  <a
                    title="imageToDisplay.caption"
                    href={INSTAGRAM_EMBED_URL}
                    target="_blank"
                    rel="noopener noreferrer">
                    <Image image={imageToDisplay.src} alt={imageToDisplay.caption} />
                  </a>
                </div>
              </div>
            ) : null}
          </div>
        ) : null}
      </section>
    </ArticleCardBase>
  );
};

export default PortraitSocialEmbedInstagram;
